var map = {
	"./captures/1.jpg": 160,
	"./themes/environment/skilift.jpg": 161,
	"./themes/environment/sydney-nye.jpg": 162,
	"./themes/message/holidays.jpg": 163,
	"./themes/message/newyear.jpg": 164
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 159;